// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__F3LEU","inputWrap":"CustomTip_inputWrap__3o2So"};